export default {
  toFixed3(val) {
    if (val && _(val).isNumber()) {
      return val.toFixed(3);
    }
    return val;
  },

  withComma(val) {
    if (val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return 0;
  },

}
